export module MousedownOutsideDetector {

  export function attach(
    element: JQuery,
    getIdFn: (element: JQuery) => string,
    downOutsideFn: (mousedownEvent: JQuery.Event) => any
  ): () => void {
    const doc = $(document);
    const eventNamespace = '.MousedownOutsideDetector' + getIdFn(element);
    const events = 'mousedown' + eventNamespace + ' touchstart' + eventNamespace;

    doc.on(events, (downEvent: JQuery.Event) => {
      const target = $(downEvent.target);
      if (target.closest(element).length === 0) {
        downOutsideFn(downEvent);
      }
    });

    return () => doc.off(eventNamespace);
  }

}
